import React, { Component } from "react";
import { connect } from 'react-redux';
import Select from 'react-select';
import { returnLabelWithValue } from 'helper/helperFunctions';
import { submitInvoicingImport } from "redux/actions/invoicing-actions";
import { getAllAgencies } from 'redux/actions/agency-actions';
//import { Link } from "react-router-dom";
import { getAgencyType } from 'redux/actions/settings-actions';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Popover,
    Button
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { settingsService } from "../../../services/settings";
import { alertActions } from "../../../redux/actions/alert-actions";

const globalSentDateOptions = [
    { value: '-1', label: 'Return date - 1 day' },
    { value: '0',  label: 'Return date' },
    { value: '1',  label: 'Return date + 1 day' },
    { value: '2',  label: 'Return date + 2 days' },
];
const globalSentTimeOptions = [
    { value: '14:00', label: '02:00 PM' },
    { value: '15:00', label: '03:00 PM' },
    { value: '16:00', label: '04:00 PM' },
    { value: '17:00', label: '05:00 PM' },
    { value: '18:00', label: '06:00 PM' },
    { value: '19:00', label: '07:00 PM' },
    { value: '20:00', label: '08:00 PM' },
    { value: '21:00', label: '09:00 PM' },
    { value: '22:00', label: '10:00 PM' },
    { value: '23:00', label: '11:00 PM' },
];



class TargetedMessageAllSettingsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            targeted_message_add_days: '0',
            targeted_message_time: '14:00'
        };
        this.handleForce = this.handleForce.bind(this);
        this.handleChangeOrderDetailDropDown = this.handleChangeOrderDetailDropDown.bind(this);
        this.handleChangeAgencyDropDown = this.handleChangeAgencyDropDown.bind(this);
    }

    getTargetedMessageAllSettings = () => {
        settingsService.getTargetedMessageAllSettings().then(response => {
            var settings = response && response.targetedMessageAllSettings
                ? response.targetedMessageAllSettings
                : {};

            this.setState({
                targeted_message_time: settings.targeted_message_time
                    ? settings.targeted_message_time.value
                    : '14:00',

                targeted_message_add_days: settings.targeted_message_add_days
                    ? settings.targeted_message_add_days.value
                    : '0',
            });
        });
    };

    componentDidMount () {
        this.getTargetedMessageAllSettings();
    }
    componentDidUpdate(prevProps, prevState) {
        // console.log('this.props.reportsData',this.props.reportsData);
        if (prevProps.settingsData !== this.props.settingsData) {
            const days = this.props.settingsData.value;
            this.setState({
                numDays: days
            })
            // console.log('updated');
        }
        if (prevProps.invData !== this.props.invData) {
            this.setState({
                newInvData: this.props.invData
            }, () => { /*console.log('this.state.newInvData',this.state.newInvData)*/ })
        }
    }

    handleChangeOrderDetailDropDown(selectedOptionType, info) {
        if (info['action'] === 'select-option') {
            this.setState({
                agency_id: selectedOptionType['value']
            }, () => { /*console.log('agency id', this.state.agency_id)*/ });
        }
    }
    handleChangeAgencyDropDown(selectedOptionType, info) {
        if (info['action'] === 'select-option') {
            this.setState({
                group_type: selectedOptionType['value']
            }, () => { /*console.log('group_type', this.state.group_type)*/ });
        }
    }

    handleForce = (data, fileName) => {
        this.setState({
            orderData: data
        }, () => { /*console.log('orderData', this.state.orderData)*/ });
    }
    updateTargetedMessageAllSettings = () => {
        const data = {
            targeted_message_add_days: this.state.targeted_message_add_days,
            targeted_message_time: this.state.targeted_message_time
        }
        console.log("data", data);
        
        settingsService.updateTargetedMessageAllSettings(data).then(
            response => {
                this.props.success(response.message);
        })
    }




    render() {
        const { group_type, agency_id, papaparseOptions, newInvData } = this.state;
        const { agenciesOption, agency_type_id } = this.props;
        //console.log('this.state...', this.state);
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card bsClass={["customCard"]} content={
                                <div>
                                    <Grid fluid>
										<Row>
											<Col md={12} >

                                                <div className="col-md-4 col-md-offset-4">
                                                    <div className="form-group" id="agency">
                                                        <label htmlFor="name">Select Global Sent Date:</label>
                                                        <Select
                                                            value={returnLabelWithValue(this.state.targeted_message_add_days, globalSentDateOptions)}
                                                            onChange={(option) =>
                                                                this.setState({ targeted_message_add_days: option.value })
                                                            }
                                                            options={globalSentDateOptions}
                                                            isSearchable={true}
                                                            isMulti={false}
                                                            name='targeted_message_add_days'
                                                            placeholder={'Global Sent Date'}
                                                        />

                                                    </div>

                                                    <div className="form-group" id="groupType">
                                                        <label htmlFor="name">Select Global Sent Time:</label>
                                                        <Select
                                                            value={returnLabelWithValue(this.state.targeted_message_time, globalSentTimeOptions)}
                                                            onChange={(option) =>
                                                                this.setState({ targeted_message_time: option.value })
                                                            }
                                                            options={globalSentTimeOptions}
                                                            isSearchable={true}
                                                            isMulti={false}
                                                            name='targeted_message_time'
                                                            placeholder={'Global Sent Time'}

                                                        />

                                                    </div>

                                                    <div className="form-group mt-md">
                                                        <OverlayTrigger placement="bottom" trigger={['hover']} overlay={<Popover id="tooltip">Save</Popover>}>
                                                            <Button type='button' className="backButton pt-sm no_radius btn-block pb-sm primary mt-none btn btn btn-info " onClick={this.updateTargetedMessageAllSettings} >Save</Button>
                                                        </OverlayTrigger>
                                                    </div>

                                                    
                                                </div>
											</Col>
										</Row>
                                    </Grid>
                                </div>
                            } />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        success: (message) => { return dispatch(alertActions.success(message)) },
    });
};

function mapStateToProps(state) {
    const { loadingAgency, agenciesOption } = state.agenciesReducer;
    const { agency_type_id } = state.settingsReducer;
    const { invData } = state.invoicingReducer;
    return {
        loadingAgency, agenciesOption, invData, agency_type_id
    };
}


const TargetedMessageAllSettings = connect(mapStateToProps, mapDispatchToProps)(TargetedMessageAllSettingsPage);
export default TargetedMessageAllSettings;